module.exports = __webpack_public_path__ + "img/home-logo-selvy.be236677.png";